/**
 * 문의 게시판 글 리스트
 *
 * @description
 *
 * @author hjkim
 * @constructor
 */
const InquiryList = () => {
  return (
    <div>
      <div>
        <div>
          <div>
            <h1>문의 게시판</h1>
            <p>궁금한 점을 문의하고 다른 사용자들의 문의와 답변을 확인해보세요.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryList;
